import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Die4.svg",
  "use": "Die4.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"Die4.svg\"><path d=\"M48,54H16a6,6,0,0,1-6-6V16a6,6,0,0,1,6-6H48a6,6,0,0,1,6,6V48A6,6,0,0,1,48,54ZM20,16a4,4,0,1,0,4,4A4,4,0,0,0,20,16Zm0,24a4,4,0,1,0,4,4A4,4,0,0,0,20,40ZM44,16a4,4,0,1,0,4,4A4,4,0,0,0,44,16Zm0,24a4,4,0,1,0,4,4A4,4,0,0,0,44,40Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol